import { LocalDate } from '../../core/model/local-date';
import { Money } from '../../core/model/money';
import { Article } from './article';
import { LeaseAgreementStatus, PropertyTaxCalculationBasis, PropertyTaxCalculationMethod } from './const/enums';
import { TaxTypeCode } from './tax-type-code';

export interface PropertyTaxRentalChangeModel {
  propertyId: string;
  premisesId: string;
  leaseAgreementId?: string | null;
  buildingName?: string | null;
  status?: LeaseAgreementStatus | null;
  statusCaption?: string | null;
  taxPercentage: number | null;
  taxPercentageDisplay?: string;
  rentalId: string;
  taxTypeCode: TaxTypeCode;
  taxTypeName?: string;
  tenantName?: string | null;
  forDebit: boolean | null;
  assessmentYear: LocalDate | null;
  invoiceableFrom?: LocalDate | null;
  surface: number;
  share: number;
  shareDisplay?: string;
  calculationBasis: string | null;
  calculationMethod: string | null;
  taxPerYear: Money | null;
  taxPerMonth: Money | null;
  taxPerYearInclVat: Money | null;
  taxPerMonthInclVat: Money | null;
  propertyTaxArticle: Article | null;
  propertyTaxArticleCaption?: string;
  propertyTaxRetroactiveArticle: Article | null;
  propertyTaxRetroactiveArticleCaption?: string;
  missedPeriodDays?: number | null;
  retroactiveAmount?: Money | null;
}

export interface PropertyTaxRentalChangeModelBase {
  propertyId: string;
  premisesId: string;
  leaseAgreementId?: string | null;
  buildingName?: string | null;
  status?: LeaseAgreementStatus | null;
  taxPercentage: number | null;
  rentalId: string;
  taxTypeCode: TaxTypeCode | null;
  tenantName?: string | null;
  forDebit: boolean | null;
  assessmentYear: LocalDate | null;
  invoiceableFrom?: LocalDate | null;
  surface: number;
  share: number;
  calculationBasis: PropertyTaxCalculationBasis | null;
  calculationMethod: PropertyTaxCalculationMethod | null;
  taxPerYear: Money | null;
  taxPerMonth: Money | null;
  taxPerYearInclVat: Money | null;
  taxPerMonthInclVat: Money | null;
  propertyTaxArticle: Article | null;
  propertyTaxRetroactiveArticle: Article | null;
}

export interface PropertyTaxLeaseAgreementChangeModel extends PropertyTaxRentalChangeModelBase {
  tenantName: string | null;
  missedPeriodDays: number | null;
  retroactiveAmount: Money | null;
}

export interface PropertyTaxRentalObjectChangeModel extends PropertyTaxRentalChangeModelBase {}

export interface PropertyTaxRentalChangesResponseModel {
  suggestedFromDate?: LocalDate | null;
  propertyTaxLeaseAgreementChangeModels: PropertyTaxLeaseAgreementChangeModel[];
  propertyTaxRentalObjectChangeModels: PropertyTaxRentalObjectChangeModel[];
}

export const EMPTY_PROPERTY_TAX_RENTAL_CHANGES_RESPONSE: PropertyTaxRentalChangesResponseModel = {
  propertyTaxLeaseAgreementChangeModels: [],
  propertyTaxRentalObjectChangeModels: [],
};
